// @flow

import type { DeviceType, WelcomeMessageProperties, PathMatcher } from '@chatchamp/chatchamp-types'

export const SHOWN_WELCOME_MESSAGE_IDS_KEY = 'trbo_ac-growth-tool-id'
// TODO; Thiago; 06.03.2024; Remove deprecated cookie in the future.
export const DEPRECATED_SHOWN_WELCOME_MESSAGE_IDS_KEY = 'chatchamp-growth-tool-id'
export const WELCOME_MESSAGE_ACTIVELY_CLOSED_COOKIE_NAME = 'trbo_ac-welcome-message-actively-closed'
// TODO; Thiago; 06.03.2024; Remove deprecated cookie in the future.
export const DEPRECATED_WELCOME_MESSAGE_ACTIVELY_CLOSED_COOKIE_NAME = 'chatchamp-welcome-message-actively-closed'
export const WELCOME_MESSAGE_PAYLOAD = 'chatchamp-welcome-message-payload'

export const TRIGGERS = {
  immediately: 'immediately',
  onExit: 'on_exit',
  timePassed: 'time_passed',
  percentScrolled: 'percent_scrolled'
}

type Trigger = $Values<typeof TRIGGERS>;

export class WelcomeMessage {
  id: number
  description: string
  trigger: Trigger
  triggerValue: any
  pathMatcher: ?PathMatcher
  regex: ?string
  default: boolean
  device: DeviceType
  type: 'welcome_message' | 'open_chat'
  properties: WelcomeMessageProperties
  payload: string
  active: boolean
  wizardUrl: string

  constructor (params: ?Object) {
    params && Object.assign(this, params)
    this.active = this.active ?? true
  }

  openChatButtons (): Array<Object> {
    const buttons = [{
      title: this.properties.openChatButtonTitle,
      type: 'open_chat'
    }]

    if (this.properties.openChatMaybeLaterButtonTitle) {
      buttons.push({
        title: this.properties.openChatMaybeLaterButtonTitle,
        type: 'maybe_later'
      })
    }

    return buttons
  }
}
